import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-team-router',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './team-router.component.html',
  styleUrl: './team-router.component.scss',
})
export class TeamRouterComponent {}
